import * as React from "react";
export default function useForceUpdate() {
    return React.useReducer(() => ({}), {})[1]; // <- paste here
}
//# sourceMappingURL=useForceUpdate.js.map